import React from 'react';
import LegalPageLayout, { LegalContactBlock, DisputeSettlementBlock } from './LegalPageLayout';
import { LEGAL_SUPPORT_EMAIL } from '../../lib/siteContact';

const ReturnRefundPolicy = () => (
  <LegalPageLayout
    title="Return & Refund Policy"
    version="Return & Refund Policy Version I"
    effectiveDate="19th Apr 2026"
  >
    <p className="legal-page__intro">
      At <strong>Innovative Info Solutions Pvt Ltd</strong>, we strive to provide high-quality
      WhatsApp Business services that meet your communication and automation needs. Please read our
      Return &amp; Refund Policy carefully before purchasing or subscribing to our services.
    </p>

    <h2>1. Nature of Services</h2>
    <p>Our offerings include but are not limited to:</p>
    <ul>
      <li>WhatsApp API integration</li>
      <li>Chatbot development and deployment</li>
      <li>Bulk messaging tools</li>
      <li>Subscription-based support and analytics dashboards</li>
    </ul>
    <p>
      As these are <strong>digital services</strong>, they are delivered electronically and may
      include non-refundable components such as third-party API costs, setup fees, or consumed
      messaging credits &amp; Monthly Platform fees. You are eligible for{' '}
      <strong>Unused credits in account</strong> against written request to stop &amp; Refund the
      available fund with reason.
    </p>

    <h2>2. Refund Eligibility</h2>
    <p>Refunds may be considered in the following cases:</p>
    <ul>
      <li>You were charged multiple times.</li>
      <li>
        The service was not delivered within the promised timeframe due to our fault.
      </li>
      <li>
        You were unable to use the service due to technical issues on our end and we failed to
        resolve them within a reasonable time of <strong>7 business days</strong>.
      </li>
      <li>
        You cancel a renewing subscription within <strong>3 business days</strong> of the renewal and
        have not used the service during that period.
      </li>
      <li>If any challenge or issue at our UI or API which dint meet your requirement.</li>
    </ul>

    <h2>3. Non-Refundable Items</h2>
    <p>We do not offer refunds for:</p>
    <ul>
      <li>One-time setup or onboarding fees once the work has started.</li>
      <li>WhatsApp messaging credits or third-party charges already consumed.</li>
      <li>
        Refund requests made after <strong>7 days</strong> from the date of purchase or renewal.
      </li>
      <li>
        Services delivered in full or partially where performance logs or communication history
        confirm delivery.
      </li>
      <li>
        Client-side issues such as misconfiguration, use of unsupported devices, or violations of
        WhatsApp&apos;s Business Policy.
      </li>
    </ul>

    <h2>4. Cancellations</h2>
    <p>
      You may cancel your subscription at any time by notifying us at{' '}
      <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a>. Cancellation will prevent
      further billing, but does not guarantee a refund for previous charges unless eligible under
      this policy.
    </p>

    <h2>5. How to Request a Refund</h2>
    <p>
      To request a refund, contact us at{' '}
      <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a> with:
    </p>
    <ul>
      <li>Your full name and company name</li>
      <li>Date and proof of purchase</li>
      <li>Description of the issue</li>
      <li>Any relevant screenshots or error messages</li>
    </ul>
    <p>
      Refund requests are typically reviewed within <strong>5 business days</strong>. If approved,
      the refund will be processed to your original method of payment within{' '}
      <strong>30 business days</strong>.
    </p>

    <h2>6. Contact Us</h2>
    <p>If you have any questions about this policy or your eligibility for a refund, please contact us:</p>
    <LegalContactBlock />

    <DisputeSettlementBlock />
  </LegalPageLayout>
);

export default ReturnRefundPolicy;
